import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { ROIState } from '~/state/atoms/structureSet/roiAtoms';
import StructureActions from './Actions';
import StructureNameField from './NameField';
import useViewManagerEvents from '~/hooks/useViewManagerEvents';

export default function StructureField({
    roi,
    onNameChange,
    isEditable,
}: {
    roi: ROIState;
    onNameChange: (value: string) => void;
    isEditable: boolean;
}) {
    const [isEditing, setIsEditing] = useState<boolean>(false);

    const { focusOnStructure } = useViewManagerEvents();
    const handleFocusOnStructure = () => {
        focusOnStructure(roi.roiNumber);
    };

    return isEditing ? (
        <StructureNameField
            roi={roi}
            onChange={onNameChange}
            onToggleEdit={(value: boolean) => setIsEditing(value)}
        />
    ) : (
        <Box
            display="grid"
            alignItems="center"
            width="100%"
            sx={{
                gridTemplateColumns: '1fr 0',
                '&:hover': {
                    gridTemplateColumns: '1fr auto',
                },
                '&:hover .buttons': {
                    visibility: 'visible',
                },
            }}
        >
            <Typography variant="body2" noWrap sx={{}} data-testid={`structure-name-${roi.name}`}>
                {roi.name}
            </Typography>
            <StructureActions
                onEdit={() => setIsEditing(true)}
                onFocus={handleFocusOnStructure}
                isEditable={isEditable}
            />
        </Box>
    );
}
